export const epostPackageProducts = {
	1955: {
		storageSize: 5,
	},
	1956: {
		storageSize: 15,
	},
};
